import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";

import { getAuthorFromCityStayedAtHotelText, getPostedAgoText, ratingDescription } from "../../hotelRecentReviewsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import {
  HotelRecentReviewsFlexModuleResult,
  HotelReview,
} from "typings/microserviceModels/hotel-recent-reviews-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const HeaderImageCard = (props: { model: HotelRecentReviewsFlexModuleResult; hotel: HotelReview }) => {
  const { model, hotel } = props;
  const { showTitleOfReviewForHeaderImageView } = model;
  const {
    hotelName,
    hotelImageUrl,
    hotelInfositeUrl,
    date: reviewPostedDate,
    rating,
    reviewTitle,
    reviewText,
    authorName,
    authorLocation,
  } = hotel;

  const { formatText } = useLocalization();

  return (
    <UitkCard>
      <UitkFigure ratio={UitkFigure.AspectRatio.R21_9}>
        <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage />
        <UitkScrim>
          <UitkHeading tag="h3" size={4} overflow="truncate-2-lines" className="uitk-type-600">
            {hotelName}
          </UitkHeading>
        </UitkScrim>
      </UitkFigure>
      <UitkCardContentSection>
        <UitkLayoutFlex direction="column">
          <UitkSpacing margin={{ blockend: "two" }}>
            <UitkText className="uitk-type-heading-400">
              {formatText("hotelRecentReviews.ratingSlashNoSpace", rating)} {ratingDescription(rating)}
            </UitkText>
          </UitkSpacing>
          {showTitleOfReviewForHeaderImageView && (
            <UitkSpacing margin={{ blockend: "two" }}>
              <UitkText className="uitk-type-heading-300">{reviewTitle}</UitkText>
            </UitkSpacing>
          )}
          <UitkSpacing margin={{ blockend: "two" }}>
            <UitkText overflow="truncate-2-lines" className="uitk-type-heading-300">
              {`\u0022${reviewText}\u0022`}
            </UitkText>
          </UitkSpacing>
          <UitkSpacing margin={{ blockend: "two" }}>
            <UitkText size={200} overflow="truncate-2-lines">
              {getAuthorFromCityStayedAtHotelText(authorName, authorLocation, hotelName)}
            </UitkText>
          </UitkSpacing>
          <UitkText size={200}>{getPostedAgoText(reviewPostedDate)}</UitkText>
        </UitkLayoutFlex>
      </UitkCardContentSection>
      <UitkCardLink>
        <TrackedLink
          moduleName="hotelRecentReviews"
          rfrr="hotelInfositeLink"
          href={hotelInfositeUrl}
          data-testid={`hotel-recent-reviews-header-image-card-${hotelName}`}
        >
          {hotelName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default HeaderImageCard;
